import uomCodes from '../../../util/uom/uom-codes';

export const status = [{ value: 'ACTIVE' }, { value: 'INACTIVE' }];
